import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
export default class InstructorTableBlockRow {
    rowType = InstructorTableRowType.BLOCK;
    blockId;
    cells = [];
    table = null;
    constructor(table) {
        this.table = table;
    }
    toSaveObject() {
        const { table, ...rest } = this;
        const saveObject = {
            ...rest,
            cells: this.cells.filter(x => x.cellType !== InstructorTableCellType.PAUSE).map(x => x.toSaveObject())
        };
        return saveObject;
    }
}
